webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(30);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(20);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Chatbot = __webpack_require__(23);
	
	var _Chatbot2 = _interopRequireDefault(_Chatbot);
	
	var _BotAdmin = __webpack_require__(21);
	
	var _BotAdmin2 = _interopRequireDefault(_BotAdmin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		routes: [{ path: '/', component: _Chatbot2.default }, { path: '/admin', component: _BotAdmin2.default }]
	});
	
	new _vue2.default({
		el: '#app',
		router: router,
		render: function render(h) {
			return h(_App2.default);
		}
	}).$mount(_App2.default);

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BotAnswerGenerator = __webpack_require__(6);
	
	var _BotAnswerGenerator2 = _interopRequireDefault(_BotAnswerGenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = {
		helloIsOpen: false,
		chatIsOpen: false,
		userName: 'Você',
		botName: 'Botzão',
		entries: [],
		oldEntries: [],
		currentUserMessage: '',
		chatWindowOpenedOnce: false,
		botIsWriting: false,
		botTypingSpeed: 75,
		botPauseOnPunctuation: 300,
		previousAnswerRef: null,
		get helloPopupMessage() {
			return !this.chatWindowOpenedOnce ? 'Oi! Me chamo ' + this.botName + '.' : '';
		},
		get letsBeginMessage() {
			return !this.chatWindowOpenedOnce ? 'Vamos começar?' : 'Converse com o ' + this.botName + ' sobre sua vida.';
		},
		get firstMessage() {
			var msg = void 0;
			if (!this.chatWindowOpenedOnce) {
				msg = 'Olá, eu sou o ' + this.botName + ' e vou conversar com você. Digite alguma coisa para começar!';
			} else {
				msg = 'Voltou? Vamos continuar conversando!';
			}
			return msg;
		},
		pushUserEntry: function pushUserEntry() {
			var _this = this;
	
			this.oldEntries = this.oldEntries.concat(this.entries);
			this.entries = [];
			this.entries.push({ sender: this.userName, message: this.currentUserMessage });
			this.pushBotEntry();
			this.$nextTick(function () {
				_this.$refs.chatOldMessages.scrollTop = _this.$refs.chatOldMessages.scrollHeight;
			});
		},
		pushBotEntry: function pushBotEntry() {
			var _this2 = this;
	
			var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var prompts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			var botMessage = { message: entry, prompts: prompts };
			if (entry == null) {
				var answer = _BotAnswerGenerator2.default.getAnswer(this.currentUserMessage, this.previousAnswerRef);
				botMessage = answer.botMessage;
				this.previousAnswerRef = answer.ref;
			}
			this.botIsWriting = true;
			setTimeout(function () {
				_this2.entries.push({ sender: _this2.botName, message: '', prompts: [] });
				_this2.writeMessage(_this2.entries[_this2.entries.length - 1], botMessage.message, 0, botMessage.prompts);
			}, 500);
		},
		writeMessage: function writeMessage(item, message, i, prompts) {
			var _this3 = this;
	
			var rand = Math.floor(Math.random() * this.botTypingSpeed);
			var m = item.message += message.charAt(i);
			var punctuation = ['.', ',', '!', '?', ':'];
	
			_lodash2.default.forEach(punctuation, function (d) {
				if (m.charAt(m.length - 1) === d) rand = _this3.botPauseOnPunctuation;
			});
	
			setTimeout(function () {
				_this3.addLetterToBotMessage(item, m);
				i++;
				if (i <= message.length) {
					_this3.writeMessage(item, message, i, prompts);
				} else {
					_this3.botIsWriting = false;
					_lodash2.default.forEach(prompts, function (d) {
						item.prompts.push(d);
					});
					_this3.$refs.chatInput.focus();
				}
			}, rand);
		},
		addLetterToBotMessage: function addLetterToBotMessage(item, message) {
			_vue2.default.set(item, 'message', message);
		},
		userSendMessage: function userSendMessage() {
			if (this.currentUserMessage.length > 0 && !this.botIsWriting) {
				this.pushUserEntry();
				this.currentUserMessage = '';
			}
		},
		promptMessage: function promptMessage(prompt) {
			this.currentUserMessage = prompt;
			this.userSendMessage();
		}
	};
	
	exports.default = store;

/***/ },
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _firebase = __webpack_require__(18);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firebaseConfig = {
		apiKey: 'AIzaSyDPvfqX_8ujP5BdKJnM1lcSQqwpLS6xxNM',
		authDomain: 'botzao-979f2.firebaseapp.com',
		databaseURL: 'https://botzao-979f2.firebaseio.com',
		storageBucket: '',
		messagingSenderId: '853920498170'
	};
	_firebase2.default.initializeApp(firebaseConfig);
	
	exports.default = _firebase2.default.database();

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Firebase = __webpack_require__(5);
	
	var _Firebase2 = _interopRequireDefault(_Firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var botAnswerGenerator = {
		ready: function ready() {
			var _this = this;
	
			_Firebase2.default.ref('respostas/').on('value', function (snapshot) {
				_lodash2.default.forEach(snapshot.val(), function (d) {
					var resposta = {
						regex: d.regex,
						botMessage: d.botMessage,
						noTalking: d.noTalking,
						ref: d.ref,
						correct: d.correct,
						wrong: d.wrong
					};
					_this.answers.push(resposta);
				});
			});
		},
	
		userMessage: '',
		botDidNotUnderstand: [{ message: 'Desculpe, não entendi muito bem o que você disse.' }, { message: 'Pode tentar dizer algo mais coerente?' }, { message: 'Não faz sentido o que você está dizendo.' }, { message: 'Não sei do que você está falando.' }, { message: 'Você escreve umas coisas bizarras.' }, { message: 'Muito bom você ter dito isso. Pena que não entendi nada.' }],
		randomPrompts: ['Começar'],
		answers: [],
		getAnswer: function getAnswer(userMessage, ref) {
			if (!ref) return this.getAnswerByRef('first');
			if (ref === 'last') return this.getAnswerByRef('lastMessage');
			var botMessage = {
				message: this.botDidNotUnderstand[this.rng(this.botDidNotUnderstand.length)].message,
				prompts: [this.randomPrompts[this.rng(this.randomPrompts.length)]],
				regex: 'teste',
				wrong: 124,
				correct: 123
			};
			if (this.rng(2) === 1) {
				var bonusPrompt = this.randomPrompts[this.rng(this.randomPrompts.length)];
				if (botMessage.prompts[0] !== bonusPrompt) botMessage.prompts.push(bonusPrompt);
			}
			this.userMessage = userMessage;
	
			var previousAnswer = this.getAnswerByRef(ref);
	
			if (this.match(previousAnswer.regex)) {
				botMessage = this.getAnswerByRef(previousAnswer.correct);
			} else {
				if (previousAnswer.wrong) botMessage = this.getAnswerByRef(previousAnswer.wrong);
			}
	
			return botMessage;
		},
		getAnswerByRef: function getAnswerByRef(ref) {
			return _lodash2.default.find(this.answers, { ref: ref });
		},
		rng: function rng(number) {
			return Math.floor(Math.random() * number);
		},
		match: function match(regex) {
			return new RegExp(regex).test(this.userMessage.toLowerCase());
		}
	};
	
	botAnswerGenerator.ready();
	
	exports.default = botAnswerGenerator;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Firebase = __webpack_require__(5);
	
	var _Firebase2 = _interopRequireDefault(_Firebase);
	
	var _vuefire = __webpack_require__(31);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	
	exports.default = {
		methods: {
			parsePrompt: function parsePrompt(prompt) {
				var p = '';
				_lodash2.default.forEach(prompt, function (d, index) {
					var separator = '';
					if (index !== 0) separator = ', ';
					p += separator + d;
				});
				return p;
			}
		},
		firebase: {
			tests: _Firebase2.default.ref('respostas/')
		}
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _BotStore = __webpack_require__(2);
	
	var _BotStore2 = _interopRequireDefault(_BotStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return _BotStore2.default;
		},
		mounted: function mounted() {
			var _this = this;
	
			this.entries = [];
			this.previousAnswerRef = null;
			this.$refs.chatInput.focus();
			this.$refs.chatOldMessages.scrollTop = this.$refs.chatOldMessages.scrollHeight;
			var prompts = !this.chatWindowOpenedOnce ? ['Vamos começar!'] : ['Vamos começar de novo!'];
			this.pushBotEntry(this.firstMessage, prompts);
			setTimeout(function () {
				_this.chatWindowOpenedOnce = true;
			}, 1000);
		},
	
		methods: {
			scrollUp: function scrollUp() {
				this.$refs.chatOldMessages.scrollTop = this.$refs.chatOldMessages.scrollTop - 40;
			},
			scrollDown: function scrollDown() {
				this.$refs.chatOldMessages.scrollTop = this.$refs.chatOldMessages.scrollTop + 40;
			},
			dismiss: function dismiss() {
				this.oldEntries.concat(this.entries);
				console.log(this.oldEntries);
				this.chatIsOpen = false;
				this.helloIsOpen = true;
			}
		}
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(24);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _ChatWindow = __webpack_require__(22);
	
	var _ChatWindow2 = _interopRequireDefault(_ChatWindow);
	
	var _BotStore = __webpack_require__(2);
	
	var _BotStore2 = _interopRequireDefault(_BotStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return _BotStore2.default;
	  },
	  mounted: function mounted() {
	    this.helloIsOpen = true;
	  },
	
	  methods: {
	    begin: function begin() {
	      this.chatIsOpen = true;
	      this.helloIsOpen = false;
	    },
	    dismissChatwindow: function dismissChatwindow() {
	      this.chatIsOpen = false;
	      this.helloIsOpen = true;
	    }
	  },
	  components: {
	    Hello: _Hello2.default,
	    ChatWindow: _ChatWindow2.default
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BotStore = __webpack_require__(2);
	
	var _BotStore2 = _interopRequireDefault(_BotStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return _BotStore2.default;
	  },
	
	  methods: {
	    begin: function begin() {
	      this.chatIsOpen = true;
	      this.helloIsOpen = false;
	    }
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(29)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(14)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(27)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-329aafa7"
	
	module.exports = __vue_exports__


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(25)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-16ca8987"
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(13)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(26)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1d503b40"
	
	module.exports = __vue_exports__


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(15)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(28)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3736aefa"
	
	module.exports = __vue_exports__


/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "chat"
	  }, [_h('div', {
	    staticClass: "chat-content"
	  }, [_h('ul', {
	    ref: "chatOldMessages",
	    staticClass: "chat-oldMessages"
	  }, [_l((oldEntries), function(entry) {
	    return _h('li', {
	      key: entry.message,
	      staticClass: "chat-message",
	      class: {
	        'is-user': entry.sender == userName, 'is-bot': entry.sender == botName
	      }
	    }, [_h('span', {
	      staticClass: "sender"
	    }, [_s(entry.sender)]), " ", _h('div', {
	      staticClass: "messageContents"
	    }, [_h('span', {
	      staticClass: "messageText"
	    }, [_s(entry.message)])])])
	  })]), " ", " ", _h('ul', {
	    staticClass: "chat-messages"
	  }, [_l((entries), function(entry) {
	    return _h('li', {
	      key: entry.message,
	      staticClass: "chat-message is-last",
	      class: {
	        'is-user': entry.sender == userName, 'is-bot': entry.sender == botName
	      }
	    }, [_h('span', {
	      staticClass: "sender"
	    }, [_s(entry.sender)]), " ", _h('div', {
	      staticClass: "messageContents"
	    }, [_h('span', {
	      staticClass: "messageText"
	    }, [_s(entry.message)]), " ", _h('div', {
	      staticClass: "chat-prompts"
	    }, [_l((entry.prompts), function(prompt) {
	      return _h('button', {
	        on: {
	          "click": function($event) {
	            promptMessage(prompt)
	          }
	        }
	      }, [_s(prompt)])
	    })])])])
	  })]), " ", _h('div', {
	    staticClass: "inputContainer"
	  }, [_h('span', {
	    staticClass: "inputLabel",
	    class: {
	      'stroke': previousAnswerRef === 'lastMessage'
	    }
	  }, ["Pergunte"]), " ", _h('div', {
	    staticClass: "chat-inputform"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (currentUserMessage),
	      expression: "currentUserMessage"
	    }],
	    ref: "chatInput",
	    staticClass: "chat-input",
	    attrs: {
	      "disabled": previousAnswerRef === 'lastMessage',
	      "type": "text"
	    },
	    domProps: {
	      "value": _s(currentUserMessage)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) return;
	        userSendMessage($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        currentUserMessage = $event.target.value
	      }
	    }
	  })])])]), " ", _h('a', {
	    staticClass: "chat-overlayClose",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": this.dismiss
	    }
	  }, [_m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('i', {
	    staticClass: "ion-close"
	  })
	}}]}

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "Chatbot"
	    }
	  }, [_h('transition', {
	    attrs: {
	      "name": "helloTrans"
	    }
	  }, [_h('hello', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (helloIsOpen),
	      expression: "helloIsOpen"
	    }],
	    attrs: {
	      "bot-name": this.botName
	    }
	  })]), " ", _h('transition', {
	    attrs: {
	      "name": "chatwindowTrans"
	    }
	  }, [(chatIsOpen) ? _h('chat-window', {
	    attrs: {
	      "bot-name": this.botName
	    }
	  }) : _e()])])
	}},staticRenderFns: []}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "BotAdmin"
	    }
	  }, [_m(0), " ", _h('table', {
	    staticClass: "table"
	  }, [_m(1), " ", _h('tbody', [_l((tests), function(test) {
	    return _h('tr', [_h('td', [_h('span', [_s(test.regex)])]), " ", _h('td', [_s(test.botMessage.message)]), " ", _h('td', [_l((test.botMessage.prompts), function(prompt) {
	      return _h('span', [_s(prompt), _m(2, true)])
	    })])])
	  })])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "form-group"
	  }, [_h('h1', ["BotAdmin"])])
	}},function (){with(this) {
	  return _h('thead', [_h('tr', {
	    attrs: {
	      "align": "left"
	    }
	  }, [_h('th', ["RegEx"]), " ", _h('th', ["Bot Message"]), " ", _h('th', ["Prompts"])])])
	}},function (){with(this) {
	  return _h('br')
	}}]}

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "hello"
	  }, [_h('h1', [_s(helloPopupMessage)]), " ", _h('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": this.begin
	    }
	  }, [_s(letsBeginMessage)])])
	}},staticRenderFns: []}

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('router-view')])
	}},staticRenderFns: []}

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.ffd2244643f8d4e73989.js
 **/